import { mapActions } from 'vuex'
import { eventBus } from '@/main'

export default {
    data() {
        return {
            inductionAttendance: {},
            inductionAttendances: [],
        }
    },
    methods: {
        ...mapActions({
            FetchInductionAttendanceByStudentIDCourseCode: 'inductionAttendance/FetchInductionAttendanceByStudentIDCourseCode',
            FetchInductionAttendancesByStudentID: 'inductionAttendance/FetchInductionAttendancesByStudentID',
            UpsertInductionAttendance: 'inductionAttendance/UpsertInductionAttendance',
        }),
        LoadInductionAttendance(studentID, courseCode) {
            eventBus.$emit('induction-attendance-fetch:started');
            this.FetchInductionAttendanceByStudentIDCourseCode({ StudentID: studentID, CourseCode: courseCode })
                .then(response => {
                    this.inductionAttendance = Object.assign({}, response);
                    eventBus.$emit('induction-attendance-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('induction-attendance-fetch:finished'));
        },
        LoadInductionAttendances(studentID) {
            eventBus.$emit('induction-attendances-fetch:started');
            this.FetchInductionAttendancesByStudentID({ StudentID: studentID })
                .then(response => {
                    this.inductionAttendances = [...response];
                    eventBus.$emit('induction-attendances-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('induction-attendances-fetch:finished'));
        },
        SaveInductionAttendance(username, displayName) {
            eventBus.$emit('induction-attendance-save:started');
            this.UpsertInductionAttendance({
                StudentID: this.inductionAttendance.studentID,
                EnrolmentID: this.inductionAttendance.enrolmentID,
                Attending: this.inductionAttendance.attending
            })
                .then(response => eventBus.$emit('induction-attendance-save:success', response))
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('induction-attendance-save:finished'));
        },
    }
};